// Copyright (c) 2022 WiseTime. All rights reserved.

import { Action } from "redux"
import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Slice from "../slice"
import * as Actions from "../actions"
import { executor, membershipService } from "../../../app/rpc"
import {
  ListSitePermissionsRequestSchema,
  ListSitePermissionsResponse,
  SitePermission,
} from "../../../generated/legebill/site/membership/v4/membership_pb"

type ListSitePermissionsRpc = (siteId: string) => Observable<ListSitePermissionsResponse>

export const listSitePermissions =
  (listSitePermissionsRpc: ListSitePermissionsRpc) => (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setCurrentSiteId.match),
      mergeMap(({ payload: { siteId }}) =>
        listSitePermissionsRpc(siteId)
          .pipe(
            map(r => ({
              siteId,
              sitePermissionsList: r.sitePermissions,
            })),
            map(Slice.setSitePermissions),
            catchError(_ => of(Actions.listSitePermissionsFailed()))
          )
      )
    )

const listSitePermissionsRpc = (siteId: string): Observable<ListSitePermissionsResponse> =>
  executor(() => membershipService.listSitePermissions(
    create(ListSitePermissionsRequestSchema, {
      siteId,
      permissionsToCheck: [
        SitePermission.MANAGE_TAGS,
        SitePermission.POST_TIME,
      ],
    })
  ))

export default listSitePermissions(listSitePermissionsRpc)
